<template>
  <fieldset>
    <SignupLegend :title="`Shareholders of ${formData.name}`"/>
    <p>Please specify individuals, who own or control over 25% shares or voting rights.</p>
    <RequiredInfoPopup/>
    <hr>
    <div :class="{scrollable: potentialShareholders.length >= 8}">
      <div class="form-check" v-for="(person, i) in potentialShareholders" :key="i">
        <input class="form-check-input" type="checkbox" :id="`dir${i}`" :required="oneShareholder"
               v-model="person.isShareholder">
        <label class="form-check-label" :for="`dir${i}`">{{person.name}}</label>
        <div class="invalid-feedback">At least one shareholder is required.</div>
      </div>
    </div>
    <div class="director" v-for="(shareholder, i) in formData.companyShareholders" :key="i">
      <hr>
      <div class="row">
        <div class="col"><h4 class="edit">{{nth(i)}} Shareholder</h4></div>
      </div>
      <BasePersonInput v-model="formData.companyShareholders[i]"/>
    </div>
    <div class="btn-toolbar justify-content-center" role="toolbar">
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-outline-primary" @click="removeShareholder" :disabled="!canRemove">
          <span class="fas fa-minus-circle"></span> remove shareholder
        </button>
        <button type="button" class="btn btn-outline-primary" @click="addShareholder" :disabled="!canAdd">
          <span class="fas fa-plus-circle"></span> add shareholder
        </button>
      </div>
    </div>
    <hr>
    <BaseNaviButtons :beforeSubmit="setShareholders" :toSubmit="formData"/>
  </fieldset>
</template>

<script>
  import BaseNaviButtons from '@/components/BaseNaviButtons'
  import BasePersonInput from '@/components/BasePersonInput'
  import helperMixin from '@/utils/helperMixin'
  import Person from '@/utils/Person'
  import RequiredInfoPopup from '@/components/RequiredInfoPopup'
  import SignupLegend from '@/components/SignupLegend'

  export default {
    components: {
      BaseNaviButtons,
      BasePersonInput,
      RequiredInfoPopup,
      SignupLegend
    },
    computed: {
      canAdd () {
        return this.formData.companyShareholders.length < 10
      },
      canRemove () {
        return this.formData.companyShareholders.length > 0
      },
      oneShareholder () {
        return !this.formData.companyDirectors.find(director => director.isShareholder) && this.formData.companyShareholders.length === 0
      },
      potentialShareholders () {
        const directorsAndOfficers = this.formData.companyDirectors.concat(this.formData.activeOfficers)
        return this.formData.chPSC.length > 0 ? this.formData.chPSC : directorsAndOfficers.filter((p, i) => directorsAndOfficers.findIndex(p2 => p2.name === p.name) === i)
      }
    },
    methods: {
      addShareholder () {
        this.formData.companyShareholders.push(new Person())
      },
      removeShareholder () {
        this.formData.companyShareholders.pop()
      },
      setShareholders () {
        const shareholders = this.formData.chPSC.concat(this.formData.companyDirectors.filter(director => director.isShareholder)).concat(this.formData.companyShareholders)
        this.formData.shareHolders = shareholders.map(d => Person.stringify(d))
        return Promise.resolve()
      }
    },
    mixins: [helperMixin],
    props: {
      formData: Object
    }
  }
</script>

<style lang="scss" scoped>
  .scrollable {
    border: 1px solid rgba(0,0,0,.1);
    display: inline-block;
    margin-bottom: 40px;
    max-height: 200px;
    overflow-y: scroll;
    padding: 20px 25px;
  }
</style>
